var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
import React from "react";
import { Paragraph } from "@riseart/common";
import { artBioCuratorThoughtCls, artBioCuratorThoughtAvatarCls } from "./CuratorThought.less";
var ArtBioCuratorThought = /* @__PURE__ */ __name(function ArtBioCuratorThought2(_ref) {
  var _ref$text = _ref.text, text = _ref$text === void 0 ? null : _ref$text, _ref$avatar = _ref.avatar, avatar = _ref$avatar === void 0 ? null : _ref$avatar;
  return /* @__PURE__ */ React.createElement("section", {
    className: artBioCuratorThoughtCls
  }, /* @__PURE__ */ React.createElement("div", {
    className: artBioCuratorThoughtAvatarCls
  }, avatar), /* @__PURE__ */ React.createElement(Paragraph, null, text));
}, "ArtBioCuratorThought");
export {
  ArtBioCuratorThought
};
